"use client";

import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}

export const ColorPicker = ({ value, onChange }: ColorPickerProps) => {
  const [color, setColor] = useState(value || '#3b82f6');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = e.target.value;
    setColor(newColor);
    onChange(newColor);
  };

  return (
    <div className="space-y-2">
      <Label>Color</Label>
      <div className="flex space-x-2">
        <Input
          type="color"
          value={color}
          onChange={handleChange}
          className="w-16 h-10 p-1"
        />
        <Input
          type="text"
          value={color}
          onChange={(e) => {
            const hex = e.target.value.replace('#', '');
            if (/^[0-9A-Fa-f]{6}$/.test(hex)) {
              setColor(`#${hex}`);
              onChange(`#${hex}`);
            }
          }}
          placeholder="#3b82f6"
          className="flex-1"
        />
        <div
          className="w-10 h-10 border rounded"
          style={{ backgroundColor: color }}
        />
      </div>
    </div>
  );
};